import { Component, OnInit, Input } from '@angular/core';
import { ISupplierSchedule } from '../../interfaces/supplier-schedule';
import { cloneDeep } from 'lodash';
import moment from 'moment';
import { Router } from '@angular/router';

@Component({
  selector: 'supplier-availability',
  templateUrl: './supplier-availability.component.html',
  styleUrls: ['./supplier-availability.component.css'],
})
export class SupplierAvailabilityComponent implements OnInit {
  constructor(private router: Router) {}

  public dayData: { weekdayName: string; dayIndex: number }[];

  private _supplierInfo: ISupplierSchedule;
  @Input('supplierInfo')
  set supplierInfo(value: ISupplierSchedule) {
    this._supplierInfo = value;
  }
  get supplierInfo(): ISupplierSchedule {
    return this._supplierInfo;
  }

  ngOnInit() {
    this.dayData = Array.apply(null, Array(7)).map(function (_, i) {
      return { weekdayName: moment(i, 'e').startOf('week').day(i).format('ddd'), dayIndex: i };
    });

    let t1: any = this.dayData.splice(0, 1)[0];
    this.dayData.push(t1);
  }

  onAvailabilityChanged(availabilityData) {
    //this.supplierInfo.supplierAvailability = cloneDeep(availabilityData);
  }

  onAvailabilityExceptionsChanged(availabilityExceptionData) {
    this.supplierInfo.supplierAvailabilityExceptions = cloneDeep(availabilityExceptionData);
  }
}
